module.exports = [
    {
        title: 'Používáme cookies',
        description: 'Súbory cookie používame na analýzu údajov o našich návštevníkoch, na zlepšenie našich webových stránok, zobrazenie personalizovaného obsahu a na to, aby sme vám poskytli skvelý zážitok z webu. Používaním tohto webu s týmto používaním súhlasíte.'
    }, {
        title: 'Prevádzkové cookies',
        description: 'Tieto súbory cookie sú nevyhnutné pre fungovanie webových stránok, nie je teda možné ich zakázať. Majte na pamäti, že niektoré stránky nebudú bez týchto súborov fungovať. Tieto súbory cookie neukladajú žiadne informácie, ktoré je možné priradiť konkrétnej osobe.',
        toggle: {
            value: 'necessary',
            enabled: true,
            readonly: true  //cookie categories with readonly=true are all treated as "necessary cookies"
        },
        cookie_table: [
            {
                col1: 'io',
                col2: location.hostname,
                col3: 'seance',
            },
            {
                col1: 'easyevent_session',
                col2: location.hostname,
                col3: 'seance',
            },
            {
                col1: 'XSRF-TOKEN',
                col2: location.hostname,
                col3: 'seance',
            },

        ]
    }, {
        title: 'Analytické cookies',
        description: 'Tyto soubory cookie se používají ke zlepšení fungování webových stránek. Umožňují nám rozpoznat a sledovat počet návštěvníků a sledovat, jak návštěvníci web používají. Tyto soubory cookie neshromažďují informace, které by vás mohly identifikovat. Pomocí těchto nástrojů analyzujeme a pravidelně zlepšujeme funkčnost našich webových stránek.',
        toggle: {
            value: 'analytics',
            enabled: false,
            readonly: false
        },
        cookie_table: [
            {
                col1: '^_ga',
                col2: 'Google.com',
                col3: '2 roky',
                is_regex: true
            },
            {
                col1: '_gid',
                col2: 'Google.com',
                col3: '1 den',
            }

        ]
    },
    {
        title: 'Interná analýza',
        description: 'Sledujeme počet návštěvníků a které stránky na webu používají. Pomocí těchto nástrojů analyzujeme a pravidelně zlepšujeme funkčnost našich webových stránek. Interní analýza nepoužívá žádné nástroje třetích stran. Pokud si přejete, aby byly sledované údaje anonymizované, vypněte tuto položku',
        toggle: {
            value: 'internal_analytics',
            enabled: false,
            readonly: false
        },
    }
]
